import apiReward from '@/api/vo-general/reward';

const defaultState = () => ({
	rewardNode: [],
	rewardNodePagination: {},
	rewardTour: [],
	rewardTourPagination: {},
	historyRewardNode: [],
	historyRewardNodePagination: {},
	historyRewardTour: [],
	historyRewardTourPagination: {},
	rewardPoint: {},

	rewardFlushOut: [],
	rewardFlushOutPagination: {},
	rewardFlushOutPoint: 0,
	historyRewardFlushOut: [],
	historyRewardFlushOutPagination: {},

	rewardPlanB: [],
	rewardPlanBPoint: 0,
	rewardPlanBPagination: {},
	historyRewardPlanB: [],
	historyRewardPlanBPagination: {},
});

const state = defaultState();

const getters = {

};

const mutations = {
	setRewardNode(state, data) {
		state.rewardNode = data.results;
		state.rewardNodePagination = data.pagination;
	},
	setRewardTour(state, data) {
		state.rewardTour = data.results;
		state.rewardTourPagination = data.pagination;
	},
	setHistoryRewardNode(state, data) {
		state.historyRewardNode = data.results;
		state.historyRewardNodePagination = data.pagination;
	},
	setHistoryRewardTour(state, data) {
		state.historyRewardTour = data.results;
		state.historyRewardTourPagination = data.pagination;
	},
	setRewardPoint(state, data) {
		state.rewardPoint = data.results;
	},

	setRewardFlushOut(state, data) {
		state.rewardFlushOut = data.results;
		state.rewardFlushOutPagination = data.pagination;
		state.rewardFlushOutPoint = data.point;
	},
	setHistoryRewardFlushOut(state, data) {
		state.historyRewardFlushOut = data.results;
		state.historyRewardFlushOutPagination = data.pagination;
	},

	setRewardPlanB(state, data) {
		state.rewardPlanB = data.results;
		state.rewardPlanBPagination = data.pagination;
		state.rewardPlanBPoint = data.point;
	},
	setHistoryRewardPlanB(state, data) {
		state.historyRewardPlanB = data.results;
		state.historyRewardPlanBPagination = data.pagination;
	},
};

const actions = {
	getRewardNode({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardNode(params).then((results) => {
				const data = results.data.data
					commit('setRewardNode', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getRewardTour({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardTour(params).then((results) => {
				const data = results.data.data
					commit('setRewardTour', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getRewardFlushOut({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardFlushOut(params).then((results) => {
				const data = results.data.data
					commit('setRewardFlushOut', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getRewardPlanB({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardPlanB(params).then((results) => {
				const data = results.data.data
					commit('setRewardPlanB', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getHistoryRewardNode({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardNode(params).then((results) => {
				const data = results.data.data
					commit('setHistoryRewardNode', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryRewardTour({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardTour(params).then((results) => {
				const data = results.data.data
					commit('setHistoryRewardTour', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryRewardFlushOut({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardFlushOut(params).then((results) => {
				const data = results.data.data
					commit('setHistoryRewardFlushOut', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryRewardPlanB({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPlanB(params).then((results) => {
				const data = results.data.data
					commit('setHistoryRewardPlanB', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getRewardPoint({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardPoint(params).then((results) => {
				const data = results.data.data
					commit('setRewardPoint', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	claimRewardTour({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardTour(params).then((results) => {
				const data = results.data
					dispatch('success', data, { root : true })
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	claimRewardFlushOut({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardFlushOut(params).then((results) => {
				const data = results.data
					dispatch('success', data, { root : true })
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	claimRewardPlanB({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardPlanB(params).then((results) => {
				const data = results.data
					dispatch('success', data, { root : true })
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};